module.exports = "/_next/static/images/d5eb9aad0836bed591aee3bafe509b81-rewards-illustration@0.5x.png.webp";